import React from 'react'
import styled, { css } from 'styled-components'

const width = '96'
const height = '22'
const viewBox = '0 0 96 22'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#A5ADBA"
      fillRule="evenodd"
      d="M77.68 8.008v2.728h-8.63v-.704c0-1.144.176-1.936 1.585-1.936l7.046-.088zm-7.574-1.672c-2.29 0-3.346 1.232-3.346 3.168v5.456h2.29v-2.64h8.63v2.552h2.29V6.336h-9.864zm12.683 0v1.672h5.372v6.952h2.29V8.008h5.373V6.336H82.789zm-30.65 5.28c0 1.232.265 1.672 1.586 1.672h9.512v1.672H53.108c-2.29 0-3.347-1.056-3.347-2.992V6.336H63.15v1.672h-11.01V9.68h10.657v1.672H52.14v.264zM35.846 9.24c-.705-.088-.793-.352-.793-.704s.176-.616.705-.616h10.48V6.336H35.495c-1.586 0-2.555.616-2.555 2.288 0 1.672.793 2.288 2.555 2.464l8.543.704c.704.088.792.264.792.704 0 .44-.176.704-.792.704H33.38v1.672H44.3c1.85 0 2.731-.704 2.731-2.552 0-1.584-.704-2.2-2.554-2.376l-8.631-.704zM0 7.832c0-.616.088-2.816.088-3.96.088-1.32.352-2.2.88-2.728C1.762.44 2.73.264 4.933.176 7.134.088 9.336 0 11.626 0c3.346 0 6.781.088 10.745.44.704.088.968.176.968.264.265.176.265.352.353 1.496.088.792.176 3.256.176 4.048-1.233-.088-8.19-.264-11.714-.264h-2.73c-.529 0-.705.088-.969.176l-.44.176 15.853 2.728v3.168L0 7.832zm12.33 13.376c-3.347 0-6.781-.088-10.745-.44-.704-.088-.968-.176-1.057-.264-.264-.176-.264-.352-.352-1.496 0-.792-.176-3.256-.176-3.96 1.233.088 8.19.264 11.714.264h2.73c.528 0 .705-.088.969-.176l.44-.176L0 12.232V9.064l23.868 4.224c0 .616-.088 2.816-.088 3.96-.088 1.32-.352 2.2-.88 2.728-.794.704-1.674.88-3.964.968a82.869 82.869 0 0 1-6.606.264z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'BrandSeat'
})
